// Central access to the public, build-time-baked platform values.
// These are injected by vite.config.ts `define` (non-secret only).
export const ENV = {
  ga4Id: __GA4_MEASUREMENT_ID__,
  sentryDsn: __SENTRY_DSN__,
  gtmId: __GTM_CONTAINER_ID__,
  feedbackProjectId: __FEEDBACK_PROJECT_ID__,
  feedbackWidgetUrl: __FEEDBACK_WIDGET_URL__,
  supabaseUrl: __SUPABASE_URL__,
  supabaseAnonKey: __SUPABASE_ANON_KEY__,
} as const;

export const hasSupabase = Boolean(ENV.supabaseUrl && ENV.supabaseAnonKey);
